import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import SupportArticlePanel from "components/SupportArticlePanel/SupportArticlePanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import { WordTemplateForListViewActivityPanel } from "WordTemplateForListView/activity/WordTemplateForListViewActivityPanel";
import { WordTemplateForListViewDetailSection } from "WordTemplateForListView/WordTemplateForListViewDetailSection";
import WordTemplateForListViewOptionsPanel from "WordTemplateForListView/WordTemplateForListViewOptionsPanel";

const WordTemplateForListViewDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.WordTemplateForListViewDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <WordTemplateForListViewDetailSection
            wordTemplateForListView={viewModel.wordTemplateForListView}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <WordTemplateForListViewOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            wordTemplateForListViewId={viewModel.wordTemplateForListView.wordTemplateForListViewId}
          />
          <SupportArticlePanel
            config={viewModel.articlePanelConfig}
          />
          <WordTemplateForListViewActivityPanel
            fileId={viewModel.wordTemplateForListView.fileId}
            config={viewModel.activityPanelConfig}
            wordTemplateForListViewId={viewModel.wordTemplateForListView.wordTemplateForListViewId}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}

export default WordTemplateForListViewDetailApp;